import React from 'react';
import ReactDOM from 'react-dom';
import '../src/assets/scss/variables.scss';
import '../src/assets/scss/index.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './pages/App';
ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);
